export default __webpack_public_path__ + "locales/si/SalesDepartmentRequestDialog.json?hash=2776ade7c9b40c0689375c430e83c712";